import { ExportFilters } from "@/models/export/filters";

export type ExportState = {
  exportFilters: ExportFilters
};

export type ExportContext = {
  state: ExportState;
  dispatch: (action: ExportActions, payload?: any) => any;
  commit: (mutation: ExportMutations, payload: any) => any;
};

export enum ExportMutations {
  SetExportFilters = "setExportFilters"
}

export enum ExportActions {
  AddExportFilters = "addExportFilters"
}

export enum ExportGetters {
  GetExportFilters = "getExportFilters"
}
